import { useState } from "react";
import { AuthSession } from "@supabase/supabase-js";
import { Link } from "react-router-dom";
import { Clock } from "lucide-react";
import { supabase } from '~/supabaseClient';
import { useNotesStore } from "~/stores/useNotesStore";
import AuthModal from "./AuthModal";
import TempoModal from "./TempoModal";
import Alert from "./ui/Alert";

export default function Header({ session }: { session: AuthSession | null }) {
  const bpm = useNotesStore((state) => state.bpm);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [showTempoModal, setShowTempoModal] = useState(false);

  return (
    <>
      <div className="z-10">
        <header className="bg-purple-950 border-b border-purple-600 flex items-center">
          <nav className="flex w-full items-center">
            {/* Left section - Logo */}
            <div className="flex-1 flex items-center px-3 py-4">
              <Link className="p-1 border-b-2 border-transparent hover:border-purple-600" to="/">
                <img className="inline-block mb-1 h-4 w-auto" src="/logo.png" alt="YO! MIDI" />
              </Link>
            </div>

            {/* Center section - BPM Button */}
            <div className="flex-0 flex justify-center items-center px-3 py-4">
              <button
                type="button"
                className="button whitespace-nowrap px-3 py-1.5 text-white font-semibold border-2 border-purple-600 rounded-lg hover:bg-purple-600 transition-colors flex items-center gap-2"
                onClick={() => setShowTempoModal(true)}
                aria-label="Open tempo and swing settings"
              >
                <Clock size={16} />
                {bpm}
              </button>
            </div>

            {/* Right section - Sign In/Out */}
            <div className="flex-1 flex justify-end items-center px-3 py-4">
              { session ? (
                <button
                  type="button"
                  className="button whitespace-nowrap p-1 text-gray-200 font-semibold border-b-2 border-transparent hover:border-purple-600"
                  onClick={() => supabase.auth.signOut()}
                >
                  Sign Out
                </button>
              ) : (
                <button
                  type="button"
                  className="button whitespace-nowrap p-1 text-gray-200 font-semibold border-b-2 border-transparent hover:border-purple-600"
                  onClick={() => setShowAuthModal(true)}
                >
                  Sign In
                </button>
              )}
            </div>
          </nav>
        </header>

        {/* WASM Migration Notice - Permanent notice during migration period */}
        <Alert variant="info">
          We're replacing our MIDI and audio libraries with WebAssembly (WASM). During the transition period you may hear playback inconsistencies or artefacts, and MIDI is likely to have problems.
        </Alert>
      </div>

      {/* Auth Modal */}
      <AuthModal isOpen={showAuthModal} onClose={() => setShowAuthModal(false)} />

      {/* Tempo & Swing Modal */}
      <TempoModal isOpen={showTempoModal} onClose={() => setShowTempoModal(false)} />
    </>
  );
}
